import { DatabaseIdTypes } from "../../../Enums/ChoiceEnums"
import { NoTzDate } from "../../DateUtils"

export interface ILookupList {
    h: number,
    encode: string,
    decode: string
}

export interface IPayerList {
    payerId: number,
    entityId: number,
    primaryPayerId: string,
    payerName: string,
    financialClassId: number,
    financialClassDescription: string,
    activeIndicator: number
}

export interface IUserList {
    idType: DatabaseIdTypes,
    id: number,
    name: string
}

export interface IFinancialReportInputs {
    searchDate?: Date,
    searchDateType?: FinancialReportDateTypes
}

export interface IFinancialReportInputsMonthly {
    searchDateStart?: Date,
    searchDateEnd?: Date,
    searchDateType?: FinancialReportDateTypes,
    selectedGroupBy1?: string,
    selectedGroupBy2?: string,
    selectedCPTCode?: string[],
    selectedUserIds?: string[],
    selectedPrimaryPayerClassIds?: number[],
    selectedPrimaryPayerIds?: number[],
    selectedRenderingProviderIds?: number[],
    selectedServiceLocationIds?: number[]
}

export interface IFinancialReportResults {
    claimId?: number,
    diagnosisId?: number,
    claimStatusId?: number,
    claimStatus?: string,
    patientId?: number,
    patientName?: string,
    dateOfService?: Date,
    formattedDateOfService?: NoTzDate,
    formattedDosYearMonth?: string,
    chargePostDate?: Date,
    lastClaimSubmissionDate?: Date,
    claimCreatorId?: string,
    renderingProviderEntityId?: number,
    renderingProviderName?: string,
    serviceLocationEntityId?: number,
    serviceLocationName?: string,
    primaryPayerFinancialClassId?: number,
    primaryPayerFinancialClassDesc?: string,
    primaryPayerEntityId?: number,
    primaryPayerName?: string,
    secondaryPayerEntityId?: number,
    secondaryPayerName?: string,
    tertiaryPayerEntityId?: number,
    tertiaryPayerName?: string,
    cptCode?: string,
    cptDesc?: string,
    depositId?: number,
    receiptId?: number,
    paymentDate?: Date,
    paymentPostDate?: Date,
    formattedPaymentPostDate?: NoTzDate,
    paymentMethodTypeId?: number,
    paymentMethod?: string,
    paymentUserId?: string,
    chargeAmount?: number,
    paymentCount?: number,
    paymentTotal?: number,
    insurancePaymentCount?: number,
    insurancePaymentTotal?: number,
    patientPaymentCount?: number,
    patientPaymentTotal?: number,
    adjustmentCount?: number,
    adjustmentTotal?: number,
    unappliedCount?: number,
    unappliedAmount?: number,
    refundTotal?: number,
    claimBalance?: number,
    claimCount?: number,
    postUserIdChargeOrPayment?: string
}

export interface IFinancialReportData {
    dailyFinancialData?: IFinancialReportResults[],
    submittedClaimData?: IFinancialReportResults[]
}

export interface IFinancialReportDataMonthly {
    monthlyGroupedFinancialData?: IFinancialReportGroupedResults[],
    monthlyGroupedSubmittedClaimData?: IFinancialReportGroupedResults[],
    monthlySummaryStats: ISummaryStats,
    monthlyFinReportDwInfo: IMonthlyFinancialDwInfo
}

export interface IMonthlyFinancialDwInfo {
    monthlyFinReport_UseDwVersion?: boolean,
    monthlyFinReport_DwLastRunDate?: Date
}

export interface ISummaryStats {
    claimsCreatedCount?: number,
    claimsCreatedAmount?: number,
    insurancePaymentCount?: number,
    insurancePaymentAmount?: number,
    patientPaymentCount?: number,
    patientPaymentAmount?: number,
    claimsSubmittedCount?: number,
    claimsSubmittedAmount?: number,
    rejectedClaimCount?: number,
    rejectedClaimAmount?: number,
    unappliedCount?: number,
    unappliedAmount?: number
}

export interface IAdvancedSearchCriteria {
    dateTypeList: IStringList[],
    selectedDateType: FinancialReportDateTypes,
    primaryPayerClassList: ILookupList[],
    selectedPrimaryPayerClassIds: number[],
    renderingProviderList: ILookupList[],
    selectedRenderingProviderIds: number[],
    primaryPayerList: IPayerList[],
    selectedPrimaryPayerIds: number[],
    serviceLocationList: ILookupList[],
    selectedServiceLocationIds: number[],
    groupByDropDownList: IDropDownList[],
    selectedGroupBy1: string,
    selectedGroupBy2?: string,
    postUserList: IUserList[],
    selectedPostUserIds: string[],
    cptCodeList: ILookupList[],
    selectedCptCodeIds: string[],
    booleanList: IBooleanList[],
    selectedIncludeRefunds: boolean,
    selectedIncludeCharges: boolean,
    selectedIncludeCounts: boolean,
    selectedIncludePaymentsAdjustments: boolean
}

export interface IFinancialReportGroupedResults {
    group1?: string,
    group2?: string,
    claimCount?: number,
    chargeAmount?: number,
    patientPaymentTotal?: number,
    insurancePaymentTotal?: number,
    unappliedAmount?: number,
    refundTotal?: number,
    paymentTotal?: number,
    adjustmentTotal?: number
}

export interface IMonthlyDrillDownInputParameters {
    searchDateStart: Date,
    searchDateEnd: Date,
    searchDateType: FinancialReportDateTypes,
    group1Column: string,
    group1Value: string,
    group2Column?: string,
    group2Value?: string
}

export interface IDropDownList {
    columnName: string,
    dropDownDescription: string
}

export interface IBooleanList {
    booleanValue: boolean,
    dropDownDescription: string
}

export interface IStringList {
    dropDownValue: string,
    dropDownDescription: string
}

export interface IReportsLandingReportList {
    reportId: number,
    reportName: string,
    reportDescription?: string,
    reportUrl: string,
    sectionId: number,
    sectionName: string,
    sectionDescription?: string,
    sectionOrder: number
}

export interface IReportsLandingKeywordList {
    keywordId: number,
    reportId: number,
    keyword: string
}

export interface IReportsLandingMultiData {
    reportsLandingReportData?: IReportsLandingReportList[],
    reportsLandingKeywordData?: IReportsLandingKeywordList[]
}


export enum FinancialTabName {
    DailySummary = "DailySummary",
    AdvancedSearch = "AdvancedSearch",
    MonthlySummary = "MonthlySummary"
}

export enum FinancialReportDateTypes {
    ServiceDepositDate = "ServiceDepositDate",
    PostDate = "PostDate",
    SubmissionDate = "SubmissionDate"
}

export enum GroupByOptions {
    CptCode = "CPT Code",
    CptDesc = "CPT with Description",
    DosDate = "DOS Date",
    DosMonthYear = "DOS Month/Year",
    ServiceLocation = "Service Location",
    PrimaryPayer = "Primary Payer",
    PrimaryPayerClass = "Primary Payer Class",
    PaymentMethod = "Payment Method",
    PostDay = "Post Day",
    PostUser = "Post User",
    RenderingProvider = "RenderingProvider"
}

export enum FinancialReportType {
    Daily = "Daily",
    Monthly = "Monthly"
}
